import BridgeEvents from "../Features/BridgeEvents";

function TwoColumnLayout(props){

    let currentFrameHeight = 0;
    const sendCurrentHeight = () => {
        if(window.disableHeightAdjustment){
            return;
        }
        let height = document.body.scrollHeight;
        if(height === currentFrameHeight){
            return
        }
        BridgeEvents.ResizeFrame(height);
        currentFrameHeight = height;
    }

    window.addEventListener("load", sendCurrentHeight);
    setInterval(sendCurrentHeight, 1000);

    return <div className={"bg-green-900 gap-0 grid grid-cols-1 lg:flex formContainer"}>
        {props.children}
    </div>;
}

export default TwoColumnLayout;
